module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("This book is dedicated to those dogs from which Damien was first drawn. To have known them was the honor of a lifetime, and the void felt now that they are gone proves false the saying “Time heals all things.”")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("In memory of The Three:")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("ARROW")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("A yellow Labrador")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Who taught me many things, but mostly that Damien exists, and that the friendship between a human and a dog truly can be among the closest bonds of this earth.")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("OTTO")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("A Doberman")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Who taught me all I ever needed to know about the heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("And heart doctors.")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("SAXON")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("A Doberman")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("A trust betrayed; she understands why I had to write this book.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("And for The One:")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("DREAD")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("A Pit Bulldog")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("With whom I shared a soul.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5126efb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 69
// module chunks = 0